import { animate, state, style, transition, trigger } from '@angular/animations';
import { T, V } from '@angular/cdk/keycodes';
import { ProtocolTypes } from 'src/app/shared/model/template';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { forEach } from 'jszip';
import moment from 'moment';
import { ApService } from 'src/app/shared/services/ap.service';
import { XdrService } from 'src/app/shared/services/xdr.service';

@Component({
  selector: 'app-device-attack-shield',
  templateUrl: './device-attack-shield.component.html',
  styleUrls: ['./device-attack-shield.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DeviceAttackShieldComponent implements OnInit {


  _dataSource: MatTableDataSource<any>;  
  _dnsDataSource: MatTableDataSource<any>;   
  _attackDataSource: MatTableDataSource<any>;
  _spamDataSource: MatTableDataSource<any>;  
  _geoipDataSource: MatTableDataSource<any>;  
  _device: any = []
  deviceId = ""
  status = ""
  state = ""
  sensitivity = ""
  logSize = ""
  stateLogSize = ""
  maxFlows = ""
  flowsUse = ""
  troublePkts = ""
  stateHistory = []
  showNote = true 
  xdrInfo_5m = {}
  displayedColumns = ["Date", "State", "Flow Total", "Flow Use %", "Trouble Strays %", "Trble Disjointed %", "Max Disjointed %", "Disjointed", "Strays", "UniqueIPs", "Action"]
  columnsToDisplayWithExpand = [ 'expand', ...this.displayedColumns,];
  dnsDisplayedColumns = ["Source", "Hostname", "MAC", "Query", "Pattern", "Timestamp"]
  xdrDisplayedColumns = ["Source IP", "Source Name", "MAC", "Destination IP", "Destination Name", "Protocol", "Packet", "Bytes", "Iface", "Timestamp"]  
  geoipDisplayedColumns = ["Source", "Destination", "Protocol", "Packet", "Byte", "Timestamp"]  
  xdrColumnWidths: Record<string, string> = {    
    Timestamp: '20%'
  };
  geoipColumnWidths: Record<string, string> = {
    Source: '20%',
    Destination: '20%',
    Protocol: '10%',
    Packet: '10%',
    Byte: '10%',
    Timestamp: '30%'
  };
  flowdoscheck_state: any = {};
  flowdoscheck_config: any = {};
  flowdoscheck_stat: any = {};
  xdrConfig: any = {};
  ashield_rule = [];
  ddos_ipset: any = {};
  col: any;
  dir: any;
  expandedElement: any = [];
  isShowDnsWatch = false;
  isShowXdr = false;
  currentPage = 1;
  page = 0
  pageSize = 10
  length = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  dnsCurrentPage = 1;
  dnsPage = 0
  dnsPageSize = 25
  dnsLength = 0;
  dnsPageSizeOptions: number[] = [5, 10, 25, 100];
  dnsPageEvent: PageEvent;
  attackCurrentPage = 1;
  attackPage = 0
  attackPageSize = 10
  attackLength = 0;
  attackPageSizeOptions: number[] = [5, 10, 25, 100];
  attackPageEvent: PageEvent;
  spamCurrentPage = 1;
  spamPage = 0
  spamPageSize = 10
  spamLength = 0;
  spamPageSizeOptions: number[] = [5, 10, 25, 100];
  spamPageEvent: PageEvent;
  geoipCurrentPage = 1;
  geoipPage = 0
  geoipPageSize = 10
  geoipLength = 0;
  geoipPageSizeOptions: number[] = [5, 10, 25, 100];
  geoipPageEvent: PageEvent;
  
  @Input() selfSort: any;
  @Input() dnsSelfSort: any;
  @Input() attackSelfSort: any;
  @Input() spamSelfSort: any;
  @Input() geoipSelfSort: any;
  @Input() set device(obj) {
    if (!obj || !obj[0]) {
      return;
    }
    this.stateHistory = []
    this._device = obj[0];
    if(this._device.baseLicense === "nfr" || this._device.addOnLicense.length < 0 || this._device.addOnLicense.filter(x=> x ==="ashield").length > 0){
      this.showNote = false
    }
    this.flowdoscheck_state = this._device.statistics?.flowdoscheck?.state || {};
    this.flowdoscheck_config = this._device.statistics?.flowdoscheck?.config || {};
    this.flowdoscheck_stat = this._device.statistics?.flowdoscheck?.statistics || {};

    this.status = this._device.statistics?.flowdoscheck.state.enabled !== undefined ? this._device.statistics?.flowdoscheck.state.enabled == 1 ? "Enabled": "Disabled": ""
    this.state = this._device.statistics?.flowdoscheck.state.STATE !== undefined ? this._device.statistics?.flowdoscheck.state.STATE : ""
    this.sensitivity = this._device.statistics?.flowdoscheck.config.mode !== undefined ? this._device.statistics?.flowdoscheck.config.mode : ""
    this.logSize = this._device.statistics?.flowdoscheck.config.log_size !== undefined ? this._device.statistics?.flowdoscheck.config.log_size: "0"
    this.stateLogSize = this._device.statistics?.flowdoscheck.config.state_log_size !== undefined ? this._device.statistics?.flowdoscheck.config.state_log_size: "0"
    this.maxFlows = this._device.statistics?.flowdoscheck.statistics.MaxFlows !== undefined ? this._device.statistics?.flowdoscheck.statistics.MaxFlows: "0"
    this.flowsUse = this._device.statistics?.flowdoscheck.statistics.FlowTotal !== undefined ? this._device.statistics?.flowdoscheck.statistics.FlowTotal: "0"
    this.troublePkts = this._device.statistics?.flowdoscheck.statistics.TroublePktsPct !== undefined ? this._device.statistics?.flowdoscheck.statistics.TroublePktsPct: "0"
    this.xdrInfo_5m = {
      Attack_5m: this._device.statistics?.flowdoscheck?.Attack_5m ?? {},
      SPAM_5m: this._device.statistics?.flowdoscheck?.SPAM_5m ?? {},
      GeoIP_5m: this._device.statistics?.flowdoscheck?.GeoIP_5m ?? {},
      DOS_5m: this._device.statistics?.flowdoscheck?.DOS_5m ?? {},
      DNSWatch_5m: this._device.statistics?.flowdoscheck?.DNSWatch_5m ?? {},
    }
    if(this._device.statistics?.flowdoscheck?.xdr_block_log && this._device.statistics?.flowdoscheck?.xdr_dnswatch){
      this.isShowDnsWatch = true;
      this.isShowXdr = true;
    }
    if(this._device.statistics?.flowdoscheck?.ashield_rule && this._device.statistics?.flowdoscheck?.ashield_rule.length > 0){
      this.ashield_rule = this._device.statistics?.flowdoscheck?.ashield_rule;
    }
    if(this._device.statistics?.flowdoscheck?.xdr_config){
      this.xdrConfig = this._device.statistics?.flowdoscheck?.xdr_config;
            
      this.xdrConfig.geoip.blocklist = Array.isArray(this.xdrConfig.geoip.blocklist)
        ? this.xdrConfig.geoip.blocklist.filter(x => x !== ",,,")
        : [];
     
      this.xdrConfig.geoip.allowlist = Array.isArray(this.xdrConfig.geoip.allowlist)
        ? this.xdrConfig.geoip.allowlist.filter(x => x !== ",,,")
        : [];
    }
    if(this._device.statistics?.flowdoscheck?.ddos_ipset){
      this.ddos_ipset = this._device.statistics?.flowdoscheck?.ddos_ipset;

    }
    // if(this._device.statistics?.flowdoscheck.state_hist !== undefined && this._device.statistics?.flowdoscheck.state_hist.length > 0){
    //   this._device.statistics?.flowdoscheck.state_hist.forEach(x=> {
    //     const csv = x.csv.replace("'","").split(",")
    //     let links = []
    //     for (let index = 12; index < x.csv.length; index+=5) {
    //       if(csv[index]){
    //         links.push({
    //           link: csv[index],
    //           iface: csv[index+1],
    //           rx: csv[index+2],
    //           tx: csv[index+3]
    //         })
    //       }          
    //     }
    //     if(csv[10] != ""){
    //       this.stateHistory.push({
    //         date: moment.unix(Number(csv[0])).tz('America/New_York').format('ddd MMM D HH:mm:ss zz YYYY'),
    //         state: csv[1],
    //         flowTotal: csv[2],
    //         flowUse: csv[3],
    //         troublePkts: csv[4],
    //         trblDisjointed: csv[5],
    //         maxDisjointed: csv[6],
    //         disjointed: csv[7],
    //         strays: csv[8],
    //         uniqueIps: csv[9],
    //         action: csv[10],
    //         links: links
    //       })
    //     }        
    //   })
    //   this._dataSource.data = this.stateHistory
    // }
    
  }

  @Output() refresh = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<any>();
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    public apService: ApService,
    public xdrService: XdrService,
    public route: ActivatedRoute,
  ) {
    this._dataSource = new MatTableDataSource<any>();
    this._dnsDataSource = new MatTableDataSource<any>();
    this._attackDataSource = new MatTableDataSource<any>();
    this._spamDataSource = new MatTableDataSource<any>();
    this._geoipDataSource = new MatTableDataSource<any>();
   }

  ngOnInit(): void {
    this.deviceId = this.route.snapshot.paramMap.get('device_id');
    this.loadData()
    this.loadDns();
    this.loadXdrAttack();
    this.loadXdrSpam();
    this.loadXdrGeoip();
  }
  handlePageEvent(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadData();
  }
  handleDnsPageEvent(event: PageEvent) {
    this.dnsCurrentPage = event.pageIndex + 1;
    this.dnsPageSize = event.pageSize;
    this.loadDns();
  }
  handleAttackPageEvent(event: PageEvent) {
    this.attackCurrentPage = event.pageIndex + 1;
    this.attackPageSize = event.pageSize;
    this.loadXdrAttack();
  }
  handleSpamPageEvent(event: PageEvent) {
    this.spamCurrentPage = event.pageIndex + 1;
    this.spamPageSize = event.pageSize;
    this.loadXdrSpam();
  }
  handleGeoipPageEvent(event: PageEvent) {
    this.geoipCurrentPage = event.pageIndex + 1;
    this.geoipPageSize = event.pageSize;
    this.loadXdrGeoip();
  }
  loadData(){
    const request =   {
      deviceId: this.deviceId,
      showSafe: true,
      page: this.currentPage,
      pageSize: this.pageSize
    }
    this.apService.getAttackShieldHist(request).subscribe(res=>{
      this.stateHistory = []      
      const response = res.data
      this.length = res.totalCount
      response.forEach(x=> {
        const csv = x.csv.replace("'","").split(",")
        let links = []
        for (let index = 12; index < x.csv.length; index+=5) {
          if(csv[index]){
            links.push({
              link: csv[index],
              iface: csv[index+1],
              rx: csv[index+2],
              tx: csv[index+3]
            })
          }          
        }
        this.stateHistory.push({
          date: moment.unix(Number(csv[0])).tz('America/New_York').format('ddd MMM D HH:mm:ss zz YYYY'),
          state: csv[1],
          flowTotal: csv[2],
          flowUse: csv[3],
          troublePkts: csv[4],
          trblDisjointed: csv[5],
          maxDisjointed: csv[6],
          disjointed: csv[7],
          strays: csv[8],
          uniqueIps: csv[9],
          action: csv[10],
          links: links
        })
      })
      this._dataSource.data = this.stateHistory
    })    
  }
  loadDns(){
    this.loadMergeXdr({
      deviceId: this.deviceId,
      type: 'dns_watch',
      page: this.dnsCurrentPage,
      pageSize: this.dnsPageSize
    })
  }
  loadXdrAttack() {
    this.loadMergeXdr({
      deviceId: this.deviceId,
      type: 'attack',
      page: this.attackCurrentPage,
      pageSize: this.attackPageSize
    })
  }

  loadXdrSpam() {
    this.loadMergeXdr({
      deviceId: this.deviceId,
      type: 'spam',
      page: this.spamCurrentPage,
      pageSize: this.spamPageSize
    })
  }

  loadXdrGeoip() {
    this.loadMergeXdr({
      deviceId: this.deviceId,
      type: 'geoip',
      page: this.geoipCurrentPage,
      pageSize: this.geoipPageSize
    })
  }

  loadMergeXdr(request: any) {
  this.xdrService.getMergedXdrLogs(this.deviceId, request)
    .subscribe(res => {

      switch (request.type) {
        case 'attack':
          this._attackDataSource.data = res.data
          this.attackLength = res.count
          break

        case 'spam':
          this._spamDataSource.data = res.data
          this.spamLength = res.count
          break

        case 'geoip':
          this._geoipDataSource.data = res.data
          this.geoipLength = res.count
          break

        case 'dns_watch':
          this._dnsDataSource.data = res.data
          this.dnsLength = res.count
          break
      }

      console.log('XDR source:', res.source)
    })
}

  trackByFn(index: number, item: string): string {
    return item;
  }
  sortData(sort: Sort) {
    if (this.selfSort) {
      const data = this.stateHistory.slice();
      if (!sort.active || sort.direction === '') {
        this._dataSource.data = data;
        return;
      }

      function compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
      }

      this._dataSource.data = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'name': return compare(a.name, b.name, isAsc);
          case 'mac': return compare(a.mac, b.mac, isAsc);
          case 'msp': return compare(a.msp, b.msp, isAsc);
          case 'domain': return compare(a.domain, b.domain, isAsc);
          case 'location': return compare(a.location, b.location, isAsc);
          case 'model': return compare(a.deviceMetaInfo.deviceModel, b.deviceMetaInfo.deviceModel, isAsc);
          case 'firmware': return compare(a.statistics.firmware ? a.statistics.firmware?.currentVersion : '', b.statistics.firmware ? b.statistics.firmware.currentVersion : '', isAsc);
          case 'baseLicense': return compare(a.baseLicense, b.baseLicense, isAsc);
          case 'orderdate': return compare(a.orderdate, b.orderdate, isAsc);
          case 'activatedAt': return compare(a.activatedAt, b.activatedAt, isAsc);
          case 'createdAt': return compare(a.createdAt, b.createdAt, isAsc);
          case 'lastSeen': return compare(a.lastSeen, b.lastSeen, isAsc);
          // case 'status': return compare(this.getStatus(a.lastSeen, a.track), this.getStatus(b.lastSeen,b.track), isAsc);
          default: return 0;
        }
      });
    }
  }
  dnsSortData(event: Sort){
    const sortField = event.active.toLowerCase();
    const direction = event.direction === 'asc' ? 1 : -1;
    this._dnsDataSource.data = [...this._dnsDataSource.data].sort((a, b) => {
    const valueA = a[sortField] ?? '';
    const valueB = b[sortField] ?? '';
    return (valueA < valueB ? -1 : 1) * direction;
  });
  }
  attackSortData(sort: Sort){

  }
  spamSortData(sort: Sort){

  }
  geoipSortData(sort: Sort){

  }
  stateColor(value){
    if (value == "Safe") {
      return "safe";
    } else if (value == "ICMP-BYTESPERPKT-ALERT!" || value == "ICMP-DISJOINTED-ALERT!" || value == "MAX-Disjointed-ALERT!" || value == "Strays-ALERT!" || value == "DNS-ALERT!" || value == "Disjointed-ALERT!") {  
        return "alert"
    } else if (value == "MAX-Disjointed-WARNING!" || value == "Strays-WARNING!" || value == "DNS-WARNING!" || value == "Disjointed-WARNING!") {
        return "warn"
    } 
  }
  formatDate(value){
    return new Date(value * 1000);
  }
  formatEnabled(value){
    if(value == 1){
      return "Enabled"
    } else if(value == 0) {
      return "Disabled"
    }
    return value
  }
  formatLocation(value, loc_type){
    const locationParts = value ? value.split(",") : [];

    switch (loc_type) {
      case 'continent':
        return locationParts[0]?.trim() || "";
      case 'country':
        return locationParts[1]?.trim() || "";
      case 'state':
        return locationParts[2]?.trim() || "";
      case 'city':
        return locationParts[3]?.trim() || "";
      default:
        return '';
    }
  }
  formatDomain(value, loc_type){
    if (!value) return '';

    const domainParts = value.split('.').map(p => p.trim()).filter(Boolean);

    switch (loc_type) {
      case 'host':
        return domainParts.length === 4 ? domainParts[0] : '';

      case 'subdomain':
        if (domainParts.length === 4) return domainParts[1];
        if (domainParts.length === 3) return domainParts[0];
        return '';

      case 'domain':
        if (domainParts.length === 4) return domainParts[2];
        if (domainParts.length === 3) return domainParts[1];
        if (domainParts.length === 2) return domainParts[0];
        return '';

      case 'ext':
        return domainParts[domainParts.length - 1] || '';

      default:
        return '';
    }
  }
  formatBase64(value): string{
    return value ? Buffer.from(value, "base64").toString(): "";
  }
  formatDosLength(value){
    
    return value === "" ? 0 : this.formatBase64(value).split('\n').length;
  }
  formatProtoTypes(value){
    return ProtocolTypes.find(x=> x.name == value)?.value ?? "";
  }

  getSelectedThreatFeedProfile(index = 0) {
    const threatFeed = this.xdrConfig?.threat_feed;
    return Array.isArray(threatFeed) && threatFeed[index]?.profile ? threatFeed[index].profile : '-';
  }
}
